import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export { concreteRouteFactory, noPropsConcreteRouteFactory, hrefConcreteRouteFactory } from "abreact/incubator/ui/app/router/simple/ConcreteRoute";

/**
 * ReactRoute stores information about an instantiated route
 */

/**
 * This interface is the basic abstraction for navigating to a route.
 *
 * It can be used both by the AbSDK router, but also by other custom implementations such as Portal proxying VDL routes.
 */

// Callers always specify RoutePropsT (do NOT default to '= any') so that goto/href calls will be strongly typed!

/**
 * Internally creates a registered RegisteredRoute instance, and then delegates its RegisteredRoute
 * interface methods to it.  This class is useful as a base class when want to add additional
 * route-specific methods (e.g., such as 'show' methods that take arbitrary objects and
 * create the props before calling the underlying 'goto' or 'href').
 */
export class DelegatingRegisteredRoute {
  constructor(routeRegistry, routeSpec) {
    _defineProperty(this, "rawRegisteredRoute", void 0);
    this.rawRegisteredRoute = routeRegistry.registerRoute(routeSpec);
  }
  get routeSpec() {
    return this.rawRegisteredRoute.routeSpec;
  }
  goto(props, routeGotoOptions) {
    return this.rawRegisteredRoute.goto(props, routeGotoOptions);
  }
  href(props) {
    return this.rawRegisteredRoute.href(props);
  }
  buildRouteFromProps(props) {
    return this.rawRegisteredRoute.buildRouteFromProps(props);
  }
  buildRouteFromParams(routeParams) {
    return this.rawRegisteredRoute.buildRouteFromParams(routeParams);
  }
}
//# sourceMappingURL=RoutingTypes.js.map
